/**
 * "Wyróżnienia" status filter checkboxes on a product category archive —
 * inc/category-archive.php's render_status_filter(). Same pattern as
 * template-parts/category-brand-filter/index.js: the checkboxes carry no
 * "name" of their own, every change joins the checked boxes into the hidden
 * "filter_status" input and submits the form.
 */

const form = document.querySelector('[data-status-filter-form]');
const hiddenValue = form?.querySelector('[data-status-filter-value]');
const checkboxes = form?.querySelectorAll('[data-status-filter-checkbox]');

if (form && hiddenValue && checkboxes?.length) {
	checkboxes.forEach((checkbox) => {
		checkbox.addEventListener('change', () => {
			const checked = Array.from(checkboxes)
				.filter((box) => box.checked)
				.map((box) => box.value);

			hiddenValue.value = checked.join(',');
			form.submit();
		});
	});
}
